import { Box, Stack, Typography, alpha } from '@mui/material';
import { Article } from 'types/blog';
import { formatDate } from 'const/blog';
import SourceAccordion from './SourceAccordion';

// ==============================|| 記事末尾の出典と運営元 ||============================== //
//
// 制度の解説記事は「誰が、何を根拠に書いたか」が信頼を左右する。
// 一次資料へのリンクと運営元をここで明示しておく。
//
// リンク先はこども家庭庁の資料。PDFを直接指しているものがあるため、
// 記事を更新するときは必ず開いて生きているか確認すること(リンク切れは逆効果になる)。

const ArticleFooter = ({ article }: { article: Article }) => (
    <Box sx={{ mt: { xs: 7, md: 9 } }}>
        {/* 章ごとの出典と同じ見た目・同じ畳み方に揃える。
            記事全体で「出典は畳んである」という扱いを一貫させるため */}
        {article.references && article.references.length > 0 && (
            <SourceAccordion title="この記事が参考にした資料（一次資料）" items={article.references} dense />
        )}

        {/* 執筆・発行元。個人名は出さず、運営会社として責任の所在を示す */}
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-between"
            sx={{ mt: 3, pt: 2.5, borderTop: `1px solid ${alpha('#111827', 0.1)}` }}
        >
            <Typography component="p" sx={{ color: '#6b7280', fontSize: '0.82rem', lineHeight: 1.8 }}>
                執筆：OHANA AI 編集部（株式会社Cocowa）
            </Typography>
            <Typography component="p" sx={{ color: '#9ca3af', fontSize: '0.82rem' }}>
                最終更新 <time dateTime={article.updatedAt}>{formatDate(article.updatedAt)}</time>
            </Typography>
        </Stack>

        <Typography component="p" sx={{ mt: 2.5, color: '#9ca3af', fontSize: '0.78rem', lineHeight: 1.9 }}>
            本記事は制度の一般的な考え方を整理したものです。様式や運用の細部は自治体によって異なる場合があります。最終的な取扱いは、指定を受けている自治体の通知および窓口の指示をご確認ください。
        </Typography>
    </Box>
);

export default ArticleFooter;
